const HongKongSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111598)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M22.0647 15.1309C21.6102 17.0215 20.8026 16.6609 20.4063 18.3097C18.0717 17.7484 16.6339 15.4007 17.1952 13.0659C17.7563 10.7313 20.1042 9.29352 22.4389 9.85485C21.6461 13.1523 22.4714 13.4401 22.0647 15.1309Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.0068 16.532C17.6643 17.5484 17.0718 18.2052 18.5173 19.0917C17.262 21.1386 14.585 21.7804 12.538 20.5252C10.491 19.27 9.8491 16.5929 11.1044 14.5459C13.9955 16.3187 14.524 15.6229 16.0068 16.532Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.4666 22.7256C16.9456 21.4633 17.3869 22.2297 18.6767 21.1289C20.2356 22.9552 20.0188 25.6996 18.1925 27.2586C16.3661 28.8176 13.6217 28.6005 12.063 26.7743C14.6422 24.5725 14.1437 23.8546 15.4666 22.7256Z"
        fill="#F0F0F0"
      />
      <path
        d="M21.1918 25.1524C20.4481 23.3558 21.3134 23.1726 20.665 21.606C22.8837 20.6878 25.4268 21.742 26.3451 23.9607C27.2633 26.1794 26.2089 28.7224 23.9903 29.6407C22.6936 26.5072 21.857 26.7594 21.1918 25.1524Z"
        fill="#F0F0F0"
      />
      <path
        d="M25.2699 20.4588C23.3314 20.6109 23.4245 19.7312 21.7342 19.8639C21.5465 17.4702 23.3351 15.3772 25.7289 15.1893C28.1227 15.0018 30.2156 16.7903 30.4033 19.1842C27.0223 19.4493 27.0036 20.3229 25.2699 20.4588Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111598">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default HongKongSvg;
